export default __webpack_public_path__ + "static/icon-pubertad-dis-d2524239e998c12dae1f76ee0b28ad76.png";